<section class="consejo-directivo mb-3">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Contacto</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <!-- Contenido de información Starts -->
      <div class="row">
        <div class="col text-center">
          <h1 class="ml-xl-3 mb-0">¡Envianos un mensaje por Whatsapp!</h1>
          <div class="number">
            <a
              href="https://wa.me/5219932785928"
              target="blank"
              class="d-flex justify-content-center whatsapp-link"
            >
              <img
                src="../../../assets/img/whatsapp.svg"
                alt="whatsapp icon"
                height="30"
              />
              <h1 class="ml-3">+ 993 278 59 28</h1>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <h2 class="mb-0">O envíanos un correo a la siguiente dirección</h2>
          <div class="number">
            <a
              href="mailto:cat@arquitab.org.mx?subject=Mira%20esta%20p&aacute;gina%20que%20me%20interes&oacute;:%20arquitab.org.mx"
              target="blank"
              class="d-flex justify-content-center whatsapp-link"
            >
              <h1>cat@arquitab.org.mx</h1>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <h2>
            También puedes seguirnos en cualquiera de nuestras redes sociales
          </h2>
          <div
            class="
              redes-container
              justify-content-center
              d-flex
              flex-row flex-wrap
            "
          >
            <a
              href="https://www.youtube.com/channel/UCUVnWVyA0SU24MfmeP0K6Pg"
              target="blank"
            >
              <fa-icon
                class="icon icon-ytb mr-3"
                [icon]="icons.youtube"
              ></fa-icon>
            </a>
            <a href="https://arquitab-blog.tumblr.com/" target="blank"
              ><fa-icon
                class="icon icon-tbl mr-3"
                [icon]="icons.tumblr"
              ></fa-icon
            ></a>
            <a href="https://www.pinterest.com.mx/catxxiiicom" target="blank">
              <fa-icon
                class="icon icon-pnt mr-3"
                [icon]="icons.pinterest"
              ></fa-icon>
            </a>
            <a href="https://www.linkedin.com/company/arquitab" target="blank">
              <fa-icon
                class="icon icon-lkn mr-3"
                [icon]="icons.linkedin"
              ></fa-icon>
            </a>
            <a
              href="https://www.instagram.com/colegio_arquis_tabasco"
              target="blank"
            >
              <fa-icon
                class="icon icon-itg mr-3"
                [icon]="icons.instagram"
              ></fa-icon>
            </a>
            <a href="https://twitter.com/ArquitectosTab" target="blank">
              <fa-icon
                class="icon icon-twt mr-3"
                [icon]="icons.twitter"
              ></fa-icon>
            </a>
            <a
              href="https://www.facebook.com/Colegiodearquitectostabasquenos"
              target="blank"
              ><fa-icon class="icon icon-fbk" [icon]="icons.facebook"></fa-icon
            ></a>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mt-2">
        <div class="col-12 text-center">
          <h2>Contactanos</h2>
          <app-contact-form></app-contact-form>
        </div>
      </div>
      <hr />
      <div class="row mt-2">
        <div class="col-12 text-center">
          <h2>Mapa</h2>
          <app-map></app-map>
        </div>
      </div>
      <!-- Contenido de información Ends -->
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
